<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <div
              class="vx-col w-full mb-base"
              v-if="article && article.length > 0"
            >
              <vs-table :data="article" class="custom-tbl">
                <template slot="thead">
                  <th style="width: 5%">#</th>
                  <th style="width: 10%">{{ $t("Account") }}</th>
                  <th style="width: 10%">{{ $t("AccountFloating") }}</th>
                  <th style="width: 13%">{{ $t("CostCenter") }}</th>
                  <th style="width: 10%">{{ $t("Debtor") }}</th>
                  <th style="width: 10%">{{ $t("Creditor") }}</th>

                </template>

                <template slot-scope="{ data }">
                  <vs-tr v-for="(row, index) in data" :key="index">
                    <vs-td>
                      {{ index + 1 }}
                    </vs-td>
                    <vs-td  style="width: 25%">
                      <div class="flex justify-center">
                        {{ row.accountName }}
                        &nbsp
                        <div style="direction: ltr"> ({{ row.accountCode }})</div>

                      </div>
                        
                    </vs-td>
                    <vs-td style="width: 20%">
                        <div class="flex justify-center" v-if="row.floatingAccountName">
                            {{ row.floatingAccountName }}
                            &nbsp
                            <div style="direction: ltr">({{ row.floatingAccountCode }})</div>

                            

                        </div>
                        <div v-else>-</div>

                    </vs-td>
                    <vs-td style="width: 15%">
                        <div class="flex justify-center" v-if="row.costCenterName">
                            {{ row.costCenterName }}
                            &nbsp
                            <div style="direction: ltr">({{ row.costCenterCode }})</div>

                        </div>
                        <div v-else>-</div>

                    </vs-td>
                    <vs-td style="width: 20%">
                        <div v-if="row.accountNature===2">
                            {{ formatPrice(row.amount) }}

                        </div>
                        <div v-else>0</div>
                    </vs-td>
                    <vs-td style="width: 20%">
                        <div v-if="row.accountNature===1">
                            {{ formatPrice(row.amount) }}

                        </div>
                        <div v-else>0</div>
                    </vs-td>


                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";

export default {
  components: {
    DataGrid,
  },
  data() {
    return {
      loaded: false,
      article:[]
    };
  },
  mounted() {
    this.load()
  },
  methods: {
    ...mapActions({
      fetchVouchersArticle: "pettyCash/fetchVouchersArticle",
    }),
    load(){
        this.fetchVouchersArticle(this.$route.params.id).then((r)=>{
            this.article=r
        })
    },
    formatPrice(value) {
      if (!value) return value;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
